module.exports = "/static/assets/7de2b48b8826dae7850c0d62c5425896.png";